var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLiveChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0886 0H12.9114C5.77909 0 0 5.77909 0 12.9114V30.55C0 37.6823 5.77909 43.4614 12.9114 43.4614H19.5177V34.7986H12.3441C10.2877 34.7986 8.62136 33.1323 8.62136 31.0759V12.6514C8.62136 10.595 10.2877 8.92864 12.3441 8.92864H39.6559C41.7123 8.92864 43.3786 10.595 43.3786 12.6514V31.0818C43.3786 33.1382 41.7123 34.8045 39.6559 34.8045H32.8309L19.5236 43.4673L19.6123 52L32.5236 43.4673H39.0886C46.2209 43.4673 52 37.6823 52 30.55V12.9114C52 5.77909 46.2209 0 39.0886 0Z",
    fill: "#FF5100"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLiveChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_live_chat.8adbb3047213ac811996fee1cd7cb81e.svg";